import React, { useState, useEffect, useRef } from 'react';
import DropdownReportOption from '../../../container/dropdown/dropdown-report-create/DropdownReportOption';
import DateRangePickerWithCalendar from '../../calendar/DateRangePickerWithCalendar';

import './TrendDetail.css';

const DateIndicator = (props) => {
  const activeStyle = {
    background: "#BEB4FF",
    color: "#ffffff"
  }
  if (props.onDateBtn == "w1") {
    return (
      <>
        <a className="button option" style={activeStyle} name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "w2") {
    return (
      <>
        <a className="button option" name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" style={activeStyle} name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "m1") {
    return (
      <>
        <a className="button option" name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" style={activeStyle} name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "m3") {
    return (
      <>
        <a className="button option" name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" style={activeStyle} name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else {
    return (
      <>
        <a className="button option" name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
}

const TimeUnitIndicator = (props) => {
  const activeStyle = {
    background: "#BEB4FF",
    color: "#ffffff"
  }
  if (props.onTimeUnitBtn == "daily") {
    return (
      <>
        <a className="button option" style={activeStyle} name="daily" onClick={(e) => props.handleTimeUnitBtn(e)}>일간</a>
        <a className="button option" name="weekly" onClick={(e) => props.handleTimeUnitBtn(e)}>주간</a>
        <a className="button option" name="monthly" onClick={(e) => props.handleTimeUnitBtn(e)}>월간</a>
      </>
    )
  }
  else if (props.onTimeUnitBtn == "weekly") {
    return (
      <>
        <a className="button option" name="daily" onClick={(e) => props.handleTimeUnitBtn(e)}>일간</a>
        <a className="button option" style={activeStyle} name="weekly" onClick={(e) => props.handleTimeUnitBtn(e)}>주간</a>
        <a className="button option" name="monthly" onClick={(e) => props.handleTimeUnitBtn(e)}>월간</a>
      </>
    )
  }
  else if (props.onTimeUnitBtn == "monthly") {
    return (
      <>
        <a className="button option" name="daily" onClick={(e) => props.handleTimeUnitBtn(e)}>일간</a>
        <a className="button option" name="weekly" onClick={(e) => props.handleTimeUnitBtn(e)}>주간</a>
        <a className="button option" style={activeStyle} name="monthly" onClick={(e) => props.handleTimeUnitBtn(e)}>월간</a>
      </>
    )
  }
  else {
    return (
      <>
        <a className="button option" name="daily" onClick={(e) => props.handleTimeUnitBtn(e)}>일간</a>
        <a className="button option" name="weekly" onClick={(e) => props.handleTimeUnitBtn(e)}>주간</a>
        <a className="button option" name="monthly" onClick={(e) => props.handleTimeUnitBtn(e)}>월간</a>
      </>
    )
  }
}

const GenderAgeIndicator = ({ onSelectionChange }) => {
  const [selected, setSelected] = useState({
    all: true,
    female: false,
    male: false,
    '10f': false,
    '20f': false,
    '30f': false,
    '40f': false,
    '50f': false,
    '10m': false,
    '20m': false,
    '30m': false,
    '40m': false,
    '50m': false,
  });

  useEffect(() => {
    onSelectionChange(selected);
  }, [selected, onSelectionChange]);

  const handleCheckboxChange = (event) => {
    // const { name, checked } = event.target;
    // let newSelection = { ...selected };

    // if (name === 'all') {
    //   // '전체' 선택 시 모든 항목을 체크 해제합니다.
    //   newSelection = {
    //     all: checked,
    //     female: false,
    //     male: false,
    //     '10f': false,
    //     '20f': false,
    //     '30f': false,
    //     '40f': false,
    //     '50f': false,
    //     '10m': false,
    //     '20m': false,
    //     '30m': false,
    //     '40m': false,
    //     '50m': false,
    //   };
    // } else {
    //   // '전체' 체크를 해제합니다.
    //   newSelection.all = false;
    //   newSelection[name] = checked;

    //   // '여성' 또는 '남성'을 선택하면, 해당하는 연령대도 선택하거나 해제합니다.
    //   if (name === 'female') {
    //     newSelection['10f'] = checked;
    //     newSelection['20f'] = checked;
    //     newSelection['30f'] = checked;
    //     newSelection['40f'] = checked;
    //     newSelection['50f'] = checked;
    //   } else if (name === 'male') {
    //     newSelection['10m'] = checked;
    //     newSelection['20m'] = checked;
    //     newSelection['30m'] = checked;
    //     newSelection['40m'] = checked;
    //     newSelection['50m'] = checked;
    //   }
    // }

    // // 선택된 항목이 없으면 '전체'를 자동으로 선택합니다.
    // const isAnySelected = Object.keys(newSelection).some(
    //   (key) => key !== 'all' && newSelection[key]
    // );

    // if (!isAnySelected) {
    //   newSelection.all = true;
    // }

    // setSelected(newSelection);
    const { name, checked } = event.target;

    // 클릭된 체크박스의 상태만 변경
    setSelected({ ...selected, [name]: checked });
  };

  return (
    <div className="gender-age-selector">
      <div className="option-row">
        <label>
          <input
            type="checkbox"
            name="all"
            checked={selected.all}
            onChange={handleCheckboxChange}
          />{' '}
          전체
        </label>
      </div>
      <div className="option-row">
        <label>
          <input
            type="checkbox"
            name="female"
            checked={selected.female}
            onChange={handleCheckboxChange}
          />{' '}
          여성
        </label>
        <label>
          <input
            type="checkbox"
            name="10f"
            checked={selected['10f']}
            onChange={handleCheckboxChange}
          />{' '}
          10대 여성
        </label>
        <label>
          <input
            type="checkbox"
            name="20f"
            checked={selected['20f']}
            onChange={handleCheckboxChange}
          />{' '}
          20대 여성
        </label>
        <label>
          <input
            type="checkbox"
            name="30f"
            checked={selected['30f']}
            onChange={handleCheckboxChange}
          />{' '}
          30대 여성
        </label>
        <label>
          <input
            type="checkbox"
            name="40f"
            checked={selected['40f']}
            onChange={handleCheckboxChange}
          />{' '}
          40대 여성
        </label>
        <label>
          <input
            type="checkbox"
            name="50f"
            checked={selected['50f']}
            onChange={handleCheckboxChange}
          />{' '}
          50대+ 여성
        </label>
      </div>
      <div className="option-row">
        <label>
          <input
            type="checkbox"
            name="male"
            checked={selected.male}
            onChange={handleCheckboxChange}
          />{' '}
          남성
        </label>
        <label>
          <input
            type="checkbox"
            name="10m"
            checked={selected['10m']}
            onChange={handleCheckboxChange}
          />{' '}
          10대 남성
        </label>
        <label>
          <input
            type="checkbox"
            name="20m"
            checked={selected['20m']}
            onChange={handleCheckboxChange}
          />{' '}
          20대 남성
        </label>
        <label>
          <input
            type="checkbox"
            name="30m"
            checked={selected['30m']}
            onChange={handleCheckboxChange}
          />{' '}
          30대 남성
        </label>
        <label>
          <input
            type="checkbox"
            name="40m"
            checked={selected['40m']}
            onChange={handleCheckboxChange}
          />{' '}
          40대 남성
        </label>
        <label>
          <input
            type="checkbox"
            name="50m"
            checked={selected['50m']}
            onChange={handleCheckboxChange}
          />{' '}
          50대+ 남성
        </label>
      </div>
    </div>
  );

}

const TrendDetailOptionBar = (props) => {
  const handleKeyPress = (e) => {
    // Enter 키를 눌렀을 때의 동작을 정의합니다.
    if (e.key === 'Enter') {
      e.preventDefault(); // 기본 줄바꿈 동작을 막습니다.
      // props.handleRunBtn(); // '실행' 버튼의 기능을 호출합니다.
    }
  };

  const MAX_QUERIES = 5;

  return (
    <>
      <div className="reportTopBg" style={{ height: '100%' }}>
        <div className="settingBox" style={{ paddingBottom: "0px" }}>
          <div className="analysis_indicator">
            <div className="indicator-box">
              날짜 <DateIndicator handleDateBtn={props.handleDateBtn} onDateBtn={props.onDateBtn} />
              &nbsp;&nbsp;<DropdownReportOption img="calendar" >
                <DateRangePickerWithCalendar authed={true} minDate={props.minDate} value={props.dateRange} onChange={props.handleDate} />
              </DropdownReportOption>
            </div>
            <div className="indicator-box" style={{ display: "inline-flex", alignItems: "center" }}>
              <span style={{ paddingLeft: "30px", width: '80px' }}>주제어&nbsp;&nbsp;</span>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                {props.trendQueries.map((query, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <textarea
                      value={query}
                      onChange={(e) => props.handleQueryChange(index, e)}
                      onKeyDown={handleKeyPress}
                      rows="1"
                      cols="15"
                      placeholder="주제어 입력"
                      style={{ width: '100%', maxWidth: '400px', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', resize: 'none' }}
                    />
                    {props.trendQueries.length > 1 && (
                      <button className="button option" onClick={() => props.handleRemoveQuery(index)} style={{ padding: '0 10px', width: '15px' }}>
                        -
                      </button>
                    )}
                    {index === props.trendQueries.length - 1 && props.trendQueries.length < MAX_QUERIES && (
                      <button className="button option" onClick={props.handleAddQuery} style={{ padding: '0 10px', width: '15px' }}>
                        +
                      </button>
                    )}
                    {/* {index === props.trendQueries.length - 1 && (
                      <button className="button option" onClick={props.handleAddQuery} style={{ padding: '0 10px', width: '15px' }}>
                        +
                      </button>
                    )} */}
                  </div>
                ))}
              </div>
            </div>
            <div className="indicator-box">
              <span style={{ paddingLeft: "30px" }}>Time Unit <TimeUnitIndicator handleTimeUnitBtn={props.handleTimeUnitBtn} onTimeUnitBtn={props.onTimeUnitBtn} /></span>
            </div>
          </div>
          <hr style={{ height: "1px", border: "0 none", color: "#ccc", backgroundColor: "#e3e3e3", margin: "7.5px" }} />
          <div className="indicator-box">
            <GenderAgeIndicator onSelectionChange={props.handleSelectionChange} />
          </div>
        </div>
        <div className="settingBtn">
          <a className="button purple" onClick={() => props.handleRunBtn()}>실행</a>&nbsp;
        </div>
      </div>
    </>
  )
}

export default TrendDetailOptionBar;